/**
 * Registro do service worker (M12-FEAT PWA). Idempotente; falha graciosamente (sem SW, o app segue
 * funcionando — so nao instala nem recebe push). So registra em https/localhost (requisito do SW).
 */
export function registerServiceWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  // O SW exige contexto seguro (https) OU localhost. O Funnel e https; o loopback e localhost.
  const secure = window.isSecureContext;
  if (!secure) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registro falhou (ex: SW desabilitado) — app segue sem PWA */
    });
  });
}
